import React, { Component } from "react";
import { Link } from "react-router-dom";
import RugPartsPanel from "./rug/rugPartsPanel";
import RugHeaderPanel from "./rug/rugHeaderPanel";
import RugSettingsMobileSidebar from "./rug/rugSettingsMobileSidebar";
import RugsWishListSidebar from "./rug/rugsWishListSidebar";
import RugsWishListMobileSidebar from "./rug/rugsWishListMobileSidebar";
import CarpetBody from "./rug/carpetBody";
import RugAPI from "../api/rug";
import RugsFilterListSidebar from "./rug/rugsFilterListSidebar";
import RugsFilterListMobile from "./rug/rugsFilterListMobile";
import { densitiesList, shanehList } from "../settings";


export default class Feed extends Component {
  state = {
    activeCarpetType: "",
    activePartsTab: "", //"border",
    toranj: null,
    corner: null,
    border: null,
    background: null,

    // Parts:
    defaultItemsLimit: 15,
    //// Toranj
    toranjItems: [],
    toranjItemsOffset: 0,
    toranjItemsError: false,
    toranjItemsLoading: true,
    toranjItemsHasMore: true,
    //// Border
    borderItems: [],
    borderItemsOffset: 0,
    borderItemsError: false,
    borderItemsLoading: true,
    borderItemsHasMore: true,
    //// Background
    backgroundItems: [],
    backgroundItemsOffset: 0,
    backgroundError: false,
    backgroundItemsLoading: true,
    backgroundItemsHasMore: true,
    //// Corner
    cornerItems: [],
    cornerItemsOffset: 0,
    cornerItemsError: false,
    cornerItemsLoading: true,
    cornerItemsHasMore: true,
    //// Tile
    tileItems: [],
    tileItemsOffset: 0,
    tileItemsError: false,
    tileItemsLoading: true,
    tileItemsHasMore: true,
    //// Kheshti Background
    kheshtiBackgroundItems: [],
    kheshtiBackgroundItemsOffset: 0,
    kheshtiBackgroundItemsError: false,
    kheshtiBackgroundItemsLoading: true,
    kheshtiBackgroundItemsHasMore: true,
    //// afshan Background
    afshanBackgroundItems: [],
    afshanBackgroundItemsOffset: 0,
    afshanBackgroundItemsError: false,
    afshanBackgroundItemsHasMore: true,
    afshanBackgroundItemsLoading: true,
    //// Modern Background
    modernBackgroundItems: [],
    modernBackgroundItemsOffset: 0,
    modernBackgroundItemsError: false,
    modernBackgroundItemsLoading: true,
    modernBackgroundItemsHasMore: true,
    //// Modern Pattern
    modernPatternItems: [],
    modernPatternItemsOffset: 0,
    modernPatternItemsError: false,
    modernPatternItemsLoading: true,
    modernPatternItemsHasMore: true,

    activeItems: [],

    // Filters
    densities: [],
    shanehs: [],
    colors: [],
    brands: [],
    yarns: [],

    // Lachak-Toranj States
    lachakToranjSelectedParts: {
      type: "lachak-toranj",
      background: {},
      border: {},
      corner: {},
      toranj: {},
    },
    // Afshan States
    afshanSelectedParts: {
      type: "afshan",
      background: {},
      border: {},
    },
    // KHeshti States
    kheshtiSelectedParts: {
      type: "kheshti",
      background: {},
      tile: {},
    },

    // Modern States
    modernSelectedParts: {
      type: "modern",
      background: {},
      pattern: {},
    },

    // Modern States
    yourPicSelectedParts: {
      type: "your_picture",
      background: {},
      pattern: {},
    },

    // Selected Rugs
    rugsWishList: [],
    widthPercent: "60%",
    class_1: {},
    class_2: {},
    class_3: {},
    class_4: {},
    class_5: {},
  };



  wishListHandler = (evt) => {
    evt.preventDefault();
    let newWishList = this.state.rugsWishList;

    switch (this.state.activeCarpetType) {
      case "lachak-toranj":
        newWishList.push({ ...this.state.lachakToranjSelectedParts });
        break;
      case "afshan":
        newWishList.push({ ...this.state.afshanSelectedParts });
        break;
      case "modern":
        newWishList.push({ ...this.state.modernSelectedParts });
        break;
      case "your_picture":
        // let newWishList = this.state.rugsWishList;

        newWishList.push({ ...this.state.yourPicSelectedParts });
        // if (newWishList.length > 4) {
        //   newWishList.shift();
        // }
        // this.setState({ rugsWishList: newWishList });  
        break;
      default:
        newWishList.push({ ...this.state.kheshtiSelectedParts });
        break;
    }

    if (newWishList.length > 4) {
      newWishList.shift();
    }

    this.setState({ rugsWishList: newWishList });
  };
  /*
  let newWishList = this.state.rugsWishList;
  newWishList.push({ ...this.state.kheshtiSelectedParts });
  if (newWishList.length > 4) {
      newWishList.shift();
    }
  this.setState({ rugsWishList: newWishList });
background = {id: 216, image: 'https://api.ghalichin.com/media/parts/1_Custom_YHgpfgT.png'}
pattern = {}
type ='modern'
  */

  partsClearHandler = (evt) => {
    switch (this.state.activeCarpetType) {
      case "lachak-toranj":
        this.setState({
          lachakToranjSelectedParts: {
            type: "lachak-toranj",
            background: {},
            border: {},
            corner: {},
            toranj: {},
          },
        });
        break;
      case "afshan":
        this.setState({
          afshanSelectedParts: {
            type: "afshan",
            background: {},
            border: {},
          },
        });
        break;
      case "modern":
        this.setState({
          modernSelectedParts: {
            type: "modern",
            background: {},
            pattern: {},
          },
        });
        break;
      default:
        this.setState({
          kheshtiSelectedParts: {
            type: "kheshti",
            background: {},
            tile: {},
          },
        });
        break;
    }
  };

  partSelectHandler = (id, image) => {
    const data = {
      id: id,
      image: image,
    };
    let part;

    this.last_selected_item();

    switch (this.state.activeCarpetType) {
      case "lachak-toranj":
        part = this.state.lachakToranjSelectedParts;
        break;
      case "afshan":
        part = this.state.afshanSelectedParts;
        break;
      case "modern":
        part = this.state.modernSelectedParts;
        break;
      default:
        part = this.state.kheshtiSelectedParts;
        break;
    }

    switch (this.state.activePartsTab) {
      case "border":
        this.set_active_type(id, 1, data);
        part.border = data;
        break;
      case "corner":
        this.set_active_type(id, 2, data);
        part.corner = data;
        break;
      case "tile":
        this.set_active_type(id, 3, data);
        part.tile = data;
        break;
      case "toranj":
        this.set_active_type(id, 4, data);
        part.toranj = data;
        break;
      case "pattern":
        this.set_active_type(id, 5, data);
        part.pattern = data;
        break;
      default:
        this.set_active_type(id, 1, data);
        part.background = data;
        break;
    }

    switch (this.state.activeCarpetType) {
      case "lachak-toranj":
        this.setState({ lachakToranjSelectedParts: part });
        break;
      case "afshan":
        this.setState({ afshanSelectedParts: part });
        break;
      case "modern":
        this.setState({ modernSelectedParts: part });
        break;
      default:

        this.setState({ kheshtiSelectedParts: part });
        break;
    }
  };

  set_active_type = (id, type, border) => {
    try {
      var item1;
      var item2;
      if (type == 1) {
        item1 = document.getElementById("image-card-" + this.state.class_1.id);
        item2 = document.getElementById("image-card-check-" + this.state.class_1.id);
      } else if (type == 2) {
        item1 = document.getElementById("image-card-" + this.state.class_2.id);
        item2 = document.getElementById("image-card-check-" + this.state.class_2.id);
      } else if (type == 3) {
        item1 = document.getElementById("image-card-" + this.state.class_3.id);
        item2 = document.getElementById("image-card-check-" + this.state.class_3.id);
      } else if (type == 4) {
        item1 = document.getElementById("image-card-" + this.state.class_4.id);
        item2 = document.getElementById("image-card-check-" + this.state.class_4.id);
      } else if (type == 5) {
        item1 = document.getElementById("image-card-" + this.state.class_5.id);
        item2 = document.getElementById("image-card-check-" + this.state.class_5.id);
      }
      item1.className = "image-card";
      item2.style = "";
    } catch { }

    try {
      if (type == 1) {
        this.state.class_1 = border;
      } else if (type == 2) {
        this.state.class_2 = border;
      } else if (type == 3) {
        this.state.class_3 = border;
      } else if (type == 4) {
        this.state.class_4 = border;
      } else if (type == 5) {
        this.state.class_5 = border;
      }

      var item = document.getElementById("image-card-" + id);
      item.className = "image-card active";
      var item = document.getElementById("image-card-check-" + id);
      item.style = "display:block;";
    }
    catch { }
  }

  last_selected_item = () => {
    try {
      setTimeout(
        () => {
          try {
            console.log(this.state.class_1);
            var item = document.getElementById("image-card-" + this.state.class_1.id);
            item.className = "image-card active";

            var item = document.getElementById("image-card-check-" + this.state.class_1.id);
            item.style = "display:block;";
          } catch { }

          try {
            console.log(this.state.class_2);
            var item = document.getElementById("image-card-" + this.state.class_2.id);
            item.className = "image-card active";

            var item = document.getElementById("image-card-check-" + this.state.class_2.id);
            item.style = "display:block;";
          } catch { }

          try {
            console.log(this.state.class_3);
            var item = document.getElementById("image-card-" + this.state.class_3.id);
            item.className = "image-card active";

            var item = document.getElementById("image-card-check-" + this.state.class_3.id);
            item.style = "display:block;";
          } catch { }

          try {
            console.log(this.state.class_4);
            var item = document.getElementById("image-card-" + this.state.class_4.id);
            item.className = "image-card active";

            var item = document.getElementById("image-card-check-" + this.state.class_4.id);
            item.style = "display:block;";
          } catch { }
        }, 500);
    } catch { }

  }

  setParts = (partType, parts) => {
    switch (partType) {
      case "toranj":
        this.setState({
          toranjItems: this.state.toranjItems.concat(parts.results),
          toranjItemsError: false,
          toranjItemsLoading: false,
          toranjItemsHasMore: !!parts.next,
        });
        break;
      case "border":
        this.setState({
          borderItems: this.state.borderItems.concat(parts.results),
          borderItemsError: false,
          borderItemsLoading: false,
          borderItemsHasMore: !!parts.next,
        });
        break;
      case "corner":
        this.setState({
          cornerItems: this.state.cornerItems.concat(parts.results),
          cornerItemsError: false,
          cornerItemsLoading: false,
          cornerItemsHasMore: !!parts.next,
        });
        break;
      case "background":
        this.setState({
          backgroundItems: this.state.backgroundItems.concat(parts.results),
          backgroundItemsError: false,
          backgroundItemsLoading: false,
          backgroundItemsHasMore: !!parts.next,
        });
        break;
      case "afshan_background":
        this.setState({
          afshanBackgroundItems: this.state.afshanBackgroundItems.concat(
            parts.results
          ),
          afshanBackgroundError: false,
          afshanBackgroundItemsLoading: false,
          afshanBackgroundItemsHasMore: !!parts.next,
        });
        break;
      case "kheshti_background":
        this.setState({
          kheshtiBackgroundItems: this.state.kheshtiBackgroundItems.concat(
            parts.results
          ),
          kheshtiBackgroundError: false,
          kheshtiBackgroundItemsLoading: false,
          kheshtiBackgroundItemsHasMore: !!parts.next,
        });
        break;
      case "modern_background":
        this.setState({
          modernBackgroundItems: this.state.modernBackgroundItems.concat(
            parts.results
          ),
          modernBackgroundError: false,
          modernBackgroundItemsLoading: false,
          modernBackgroundItemsHasMore: !!parts.next,
        });
        break;
      case "pattern":
        this.setState({
          modernPatternItems: this.state.modernPatternItems.concat(
            parts.results
          ),
          modernPatternError: false,
          modernPatternItemsLoading: false,
          modernPatternItemsHasMore: !!parts.next,
        });
        break;
      case "tile":
        this.setState({
          tileItems: parts.results,
          tileItemsError: false,
          tileItemsLoading: false,
          tileItemsHasMore: !!parts.next,
        });
        break;
      default:
        break;
    }

    if (partType === this.state.activePartsTab) {
      this.setActiveItems(partType);
    }
  };

  setLoading = (partType) => {
    switch (partType) {
      case "toranj":
        this.setState({
          toranjItemsLoading: true,
        });
        break;
      case "border":
        this.setState({
          borderItemsLoading: true,
        });
        break;
      case "corner":
        this.setState({
          cornerItemsLoading: true,
        });
        break;
      case "background":
        this.setState({
          backgroundItemsLoading: true,
        });
        break;
      case "afshan_background":
        this.setState({
          afshanBackgroundItemsLoading: true,
        });
        break;
      case "kheshti_background":
        this.setState({
          kheshtiBackgroundItemsLoading: true,
        });
        break;
      case "modern_background":
        this.setState({
          modernBackgroundItemsLoading: true,
        });
        break;
      case "pattern":
        this.setState({
          modernPatternItemsLoading: true,
        });
        break;
      case "tile":
        this.setState({
          tileItemsLoading: false,
        });
        break;
      default:
        break;
    }
  };

  getOffset = (partType) => {
    switch (partType) {
      case "toranj":
        return this.state.toranjItemsOffset;
      case "border":
        return this.state.borderItemsOffset;
      case "corner":
        return this.state.cornerItemsOffset;
      case "background":
        return this.state.backgroundItemsOffset;
      case "kheshti_background":
        return this.state.kheshtiBackgroundItemsOffset;
      case "afshan_background":
        return this.state.kheshtiBackgroundItemsOffset;
      case "modern_background":
        return this.state.modernBackgroundItemsOffset;
      case "pattern":
        return this.state.modernPatternItemsOffset;
      case "tile":
        return this.state.tileItemsOffset;
      default:
        return 0;
    }
  };

  loadParts = (partType) => {
    this.setLoading(partType);
    const rugAPIObj = new RugAPI();
    rugAPIObj
      .getPartsList(
        partType,
        this.state.brands,
        this.state.yarns,
        this.state.shanehs,
        this.state.densities,
        this.state.colors,
        this.state.defaultItemsLimit,
        this.getOffset(partType)
      )
      .then((response) => {
        if (response.success) {
          this.setParts(partType, response.data);
        } else {
          this.setState({ toranjItemsError: true, toranjItemsLoading: false });
        }
      });
    this.last_selected_item();
  };

  carpetTypeHandler = (typeName) => {
    this.last_selected_item();
    if (typeName !== this.state.activeCarpetType) {
      let activePartsTab;
      let items;
      switch (typeName) {
        case "kheshti":
          activePartsTab = "tile";
          items = this.state.tileItems;
          break;
        case "modern":
          activePartsTab = "modern_background";
          items = this.state.modernBackgroundItems;
          break;
        case "your_picture":
          activePartsTab = "your_picture";
          items = this.state.modernBackgroundItems;
          break;
        default:
          activePartsTab = "border";
          items = this.state.borderItems;
          break;
      }
      document.getElementById("partsSlider").scrollLeft = 0;
      this.setState({
        activeCarpetType: typeName,
        activePartsTab: activePartsTab,
        activeItems: items,
      });
    }
  };

  partsTabHandler = (tabName) => {
    this.last_selected_item();
    if (this.state.activePartsTab !== tabName) {
      switch (tabName) {
        case "border":
          this.setState({
            activePartsTab: tabName,
            activeItems: this.state.borderItems,
          });
          break;
        case "toranj":
          this.setState({
            activePartsTab: tabName,
            activeItems: this.state.toranjItems,
          });
          break;
        case "corner":
          this.setState({
            activePartsTab: tabName,
            activeItems: this.state.cornerItems,
          });
          break;
        case "tile":
          this.setState({
            activePartsTab: tabName,
            activeItems: this.state.tileItems,
          });
          break;
        case "afshan_background":
          this.setState({
            activePartsTab: tabName,
            activeItems: this.state.afshanBackgroundItems,
          });
          break;
        case "kheshti_background":
          this.setState({
            activePartsTab: tabName,
            activeItems: this.state.kheshtiBackgroundItems,
          });
          break;
        case "modern_background":
          this.setState({
            activePartsTab: tabName,
            activeItems: this.state.modernBackgroundItems,
          });
          break;
        case "pattern":
          this.setState({
            activePartsTab: tabName,
            activeItems: this.state.modernPatternItems,
          });
          break;
        default:
          this.setState({
            activePartsTab: tabName,
            activeItems: this.state.backgroundItems,
          });
          break;
      }
      if (tabName != "") {
        document.getElementById("partsSlider").scrollLeft = 0;
      }
    }
  };

  loadAllParts = () => {
    this.loadParts("toranj");
    this.loadParts("border");
    this.loadParts("corner");
    this.loadParts("background");
    this.loadParts("kheshti_background");
    this.loadParts("afshan_background");
    this.loadParts("modern_background");
    this.loadParts("pattern");
    this.loadParts("tile");
  };

  setActiveItems = (activeTab) => {
    switch (activeTab) {
      case "border":
        this.setState({ activeItems: this.state.borderItems });
        break;
      case "corner":
        this.setState({ activeItems: this.state.cornerItems });
        break;
      case "background":
        this.setState({ activeItems: this.state.backgroundItems });
        break;
      case "toranj":
        this.setState({ activeItems: this.state.toranjItems });
        break;
      case "tile":
        this.setState({ activeItems: this.state.tileItems });
        break;
      case "afshan_background":
        this.setState({ activeItems: this.state.afshanBackgroundItems });
        break;
      case "kheshti_background":
        this.setState({ activeItems: this.state.kheshtiBackgroundItems });
        break;
      case "modern_background":
        this.setState({ activeItems: this.state.modernBackgroundItems });
        break;
      case "pattern":
        this.setState({ activeItems: this.state.modernPatternItems });
        break;
      default:
        break;
    }
  };

  componentDidMount() {
    this.loadAllParts();
    window.addEventListener("resize", this.updateWidth);
    this.updateWidth(); // initialize on mount
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWidth);
  }

  addOrRemoveFromArray = (arr, value) => {
    let finalArray = arr;
    if (arr.indexOf(value) === -1) {
      finalArray.push(value);
    } else {
      finalArray.splice(finalArray.indexOf(value), 1);
    }
    return finalArray;
  };

  getDensities = (shanehs) => {
    if (this.state.densities.length === 0) {
      return [];
    } else if (shanehs.length === 0) {
      return this.state.densities;
    }

    let newDensities = [];
    let newSelectedDensities = [];
    if (shanehs.length === 0) {
      newDensities = densitiesList;
    } else {
      shanehs.forEach((shaneh) => {
        newDensities = newDensities.concat(shanehList[shaneh]);
      });
    }

    this.state.densities.forEach((density) => {
      if (newDensities.indexOf(density) !== -1) {
        newSelectedDensities.push(density);
      }
    });
    return newSelectedDensities;
  };

  shouldLoadMoreItems = () => {
    switch (this.state.activePartsTab) {
      case "border":
        return !this.state.borderItemsLoading && this.state.borderItemsHasMore;
      case "corner":
        return !this.state.cornerItemsLoading && this.state.cornerItemsHasMore;
      case "background":
        return (
          !this.state.backgroundItemsLoading &&
          this.state.backgroundItemsHasMore
        );
      case "afshan_background":
        return (
          !this.state.afshanBackgroundItemsLoading &&
          this.state.afshanBackgroundItemsHasMore
        );
      case "kheshti_background":
        return (
          !this.state.kheshtiBackgroundItemsLoading &&
          this.state.kheshtiBackgroundItemsHasMore
        );
      case "modern_background":
        return (
          !this.state.modernBackgroundItemsLoading &&
          this.state.modernBackgroundItemsHasMore
        );
      case "pattern":
        return (
          !this.state.modernPatternItemsLoading &&
          this.state.modernPatternItemsHasMore
        );
      case "toranj":
        return !this.state.toranjItemsLoading && this.state.toranjItemsHasMore;
      case "tile":
        return !this.state.tileItemsLoading && this.state.tileItemsHasMore;
      default:
        return true;
    }
  };

  itemsScrollHandler = () => {
    if (this.shouldLoadMoreItems()) {
      switch (this.state.activePartsTab) {
        case "border":
          this.setState(
            {
              borderItemsOffset:
                this.state.borderItemsOffset + this.state.defaultItemsLimit,
            },
            () => this.loadParts(this.state.activePartsTab)
          );
          break;
        case "corner":
          this.setState(
            {
              cornerItemsOffset:
                this.state.cornerItemsOffset + this.state.defaultItemsLimit,
            },
            () => this.loadParts(this.state.activePartsTab)
          );
          break;
        case "toranj":
          this.setState(
            {
              toranjItemsOffset:
                this.state.toranjItemsOffset + this.state.defaultItemsLimit,
            },
            () => this.loadParts(this.state.activePartsTab)
          );
          break;
        case "tile":
          this.setState(
            {
              tileItemsOffset:
                this.state.tileItemsOffset + this.state.defaultItemsLimit,
            },
            () => this.loadParts(this.state.activePartsTab)
          );
          break;
        case "background":
          this.setState(
            {
              backgroundItemsOffset:
                this.state.backgroundItemsOffset + this.state.defaultItemsLimit,
            },
            () => this.loadParts(this.state.activePartsTab)
          );
          break;
        case "afshan_background":
          this.setState(
            {
              afshanBackgroundItemsOffset:
                this.state.afshanBackgroundItemsOffset +
                this.state.defaultItemsLimit,
            },
            () => this.loadParts(this.state.activePartsTab)
          );
          break;
        case "kheshti_background":
          this.setState(
            {
              kheshtiBackgroundItemsOffset:
                this.state.kheshtiBackgroundItemsOffset +
                this.state.defaultItemsLimit,
            },
            () => this.loadParts(this.state.activePartsTab)
          );
          break;
        case "modern_background":
          this.setState(
            {
              moderniBackgroundItemsOffset:
                this.state.modernBackgroundItemsOffset +
                this.state.defaultItemsLimit,
            },
            () => this.loadParts(this.state.activePartsTab)
          );
          break;
        case "pattern":
          this.setState(
            {
              moderniPatternItemsOffset:
                this.state.modernPatternItemsOffset +
                this.state.defaultItemsLimit,
            },
            () => this.loadParts(this.state.activePartsTab)
          );
          break;
        default:
          return;
      }
    }
  };

  resetParts = () => {
    this.setState({
      toranjItems: [],
      toranjItemsOffset: 0,
      toranjItemsError: false,
      toranjItemsHasMore: true,
      //// Border
      borderItems: [],
      borderItemsOffset: 0,
      borderItemsError: false,
      borderItemsHasMore: true,
      //// Background
      backgroundItems: [],
      backgroundItemsOffset: 0,
      backgroundError: false,
      backgroundItemsHasMore: true,
      //// Corner
      cornerItems: [],
      cornerItemsOffset: 0,
      cornerItemsError: false,
      cornerItemsHasMore: true,
      //// Tile
      tileItems: [],
      tileItemsOffset: 0,
      tileItemsError: false,
      tileItemsHasMore: true,
      //// Kheshti Background
      kheshtiBackgroundItems: [],
      kheshtiBackgroundItemsOffset: 0,
      kheshtiBackgroundItemsError: false,
      kheshtiBackgroundItemsHasMore: true,
      //// afshan Background
      afshanBackgroundItems: [],
      afshanBackgroundItemsOffset: 0,
      afshanBackgroundItemsError: false,
      afshanBackgroundItemsHasMore: true,
      //// Modern Background
      modernBackgroundItems: [],
      modernBackgroundItemsOffset: 0,
      modernBackgroundItemsError: false,
      modernBackgroundItemsHasMore: true,
      //// Modern Pattern
      modernPatternItems: [],
      modernPatternItemsOffset: 0,
      modernPatternItemsError: false,
      modernPatternItemsHasMore: true,
    });
  };

  filterChangeHandler = (type, id) => {
    this.resetParts();
    let newData;
    switch (type) {
      case "brands":
        newData = this.addOrRemoveFromArray(this.state.brands, id);
        this.setState({ brands: newData, activeItems: [] }, () => {
          this.loadAllParts();
        });
        break;
      case "shanehs":
        newData = this.addOrRemoveFromArray(this.state.shanehs, id);
        // Remove densities that aren't allowed for current shanehs
        let newDensities = this.getDensities(newData);
        this.setState(
          { shanehs: newData, densities: newDensities, activeItems: [] },
          () => {
            this.loadAllParts();
          }
        );
        break;
      case "densities":
        newData = this.addOrRemoveFromArray(this.state.densities, id);
        this.setState({ densities: newData, activeItems: [] }, () => {
          this.loadAllParts();
        });
        break;
      case "yarns":
        newData = this.addOrRemoveFromArray(this.state.yarns, id);
        this.setState({ yarns: newData, activeItems: [] }, () => {
          this.loadAllParts();
        });
        break;
      case "colors":
        newData = this.addOrRemoveFromArray(this.state.colors, id);
        this.setState({ colors: newData, activeItems: [] }, () => {
          this.loadAllParts();
        });
        break;
      default:
        break;
    }
  };

  updateWidth = () => {
    const w = window.innerWidth;

    // فرمول خطی: از 60% تا 100% بین 400px و 1600px
    const minW = 400;
    const maxW = 1600;

    // محدود کردن بین min و max
    const clamped = Math.max(minW, Math.min(w, maxW));

    // محاسبه درصد: وقتی w=maxW → 60% ، وقتی w=minW → 100%
    var percent = 60 + ((maxW - clamped) / (maxW - minW)) * 60;
    if(percent > 100) {
      percent = 100;
    }
    this.setState({ widthPercent: `${percent}%` });
  };

  toggleContent = () => {
    this.setState(prev => ({ open: !prev.open }));
  };

  addYourPicToWishList = (any) => {
    this.state.yourPicSelectedParts = any;
    this.setState({ yourPicSelectedParts: any });
  }

  render() {
    const { widthPercent } = this.state;
    const { open } = this.state;

    return (


      <div>
        <div className="container full-body">
          <div className="row">
            <div className="col-12 mb-5">
              {/* <RugsFilterListMobile
                globalState={this.state}
                texts={this.props.texts}
                filterChangeHandler={this.filterChangeHandler}
                yarns={this.state.yarns}
                densities={this.state.densities}
                brands={this.state.brands}
                shanehs={this.state.shanehs}
                colors={this.state.colors}
              /> */}
              <RugSettingsMobileSidebar
                texts={this.props.texts}
                activeType={this.state.activeCarpetType}
                carpetTypeHandler={this.carpetTypeHandler}
              />
              {/* <RugsFilterListSidebar
                globalState={this.state}
                texts={this.props.texts}
                filterChangeHandler={this.filterChangeHandler}
                yarns={this.state.yarns}
                densities={this.state.densities}
                brands={this.state.brands}
                shanehs={this.state.shanehs}
                colors={this.state.colors}
              /> */}

              <RugHeaderPanel
                texts={this.props.texts}
                globalState={this.state}
                carpetTypeHandler={this.carpetTypeHandler}
                partsTabHandler={this.partsTabHandler}
                partSelectHandler={this.partSelectHandler}
                itemsScrollHandler={this.itemsScrollHandler}
                //------------------------------------------
                filterChangeHandler={this.filterChangeHandler}
                yarns={this.state.yarns}
                densities={this.state.densities}
                brands={this.state.brands}
                shanehs={this.state.shanehs}
                colors={this.state.colors}
              />

              <div className="text-center shadow-div" style={{ width: widthPercent }}>
                <RugPartsPanel
                  texts={this.props.texts}
                  globalState={this.state}
                  carpetTypeHandler={this.carpetTypeHandler}
                  partsTabHandler={this.partsTabHandler}
                  partSelectHandler={this.partSelectHandler}
                  itemsScrollHandler={this.itemsScrollHandler}
                  filterChangeHandler={this.filterChangeHandler}
                  addYourPicToWishList={this.addYourPicToWishList}
                />
                <CarpetBody
                  texts={this.props.texts}
                  globalState={this.state}
                  partsClearHandler={this.partsClearHandler}
                  filterChangeHandler={this.filterChangeHandler}
                />


                {/* <div className="w-100 text-center">
                  <button
                    className="btn-preview normal-add"
                    onClick={this.wishListHandler}
                  >
                    <svg
                      version="1.1"
                      x="0px"
                      y="0px"
                      viewBox="0 0 240.823 240.823"
                      enableBackground="new 0 0 240.823 240.823"
                    >
                      <g>
                        <path
                          d="M57.633,129.007L165.93,237.268c4.752,4.74,12.451,4.74,17.215,0c4.752-4.74,4.752-12.439,0-17.179
                            l-99.707-99.671l99.695-99.671c4.752-4.74,4.752-12.439,0-17.191c-4.752-4.74-12.463-4.74-17.215,0L57.621,111.816
                            C52.942,116.507,52.942,124.327,57.633,129.007z"
                        />
                      </g>
                    </svg>
                    {this.props.texts["addToWishList"]}
                  </button>
                  {this.state.rugsWishList.length < 1 && (
                    <>
                      <button className="btn-preview mobile-preview" disabled>
                        <svg
                          version="1.1"
                          x="0px"
                          y="0px"
                          viewBox="0 0 240.823 240.823"
                          enableBackground="new 0 0 240.823 240.823"
                        >
                          <g>
                            <path
                              d="M57.633,129.007L165.93,237.268c4.752,4.74,12.451,4.74,17.215,0c4.752-4.74,4.752-12.439,0-17.179
                          l-99.707-99.671l99.695-99.671c4.752-4.74,4.752-12.439,0-17.191c-4.752-4.74-12.463-4.74-17.215,0L57.621,111.816
                          C52.942,116.507,52.942,124.327,57.633,129.007z"
                            />
                          </g>
                        </svg>
                        {this.props.texts["preview"]}
                      </button>
                      <p style={{ fontSize: 13, marginTop: 10, color: "red" }}>
                        {this.props.texts["previewEmptyHelpText"]}
                      </p>
                    </>
                  )}
                  {this.state.rugsWishList.length > 0 && (
                    <Link
                      to={{
                        pathname: "/preview",
                        state: { rugs: this.state.rugsWishList },
                      }}
                    >
                      <button className="btn-preview mobile-preview">
                        <svg
                          version="1.1"
                          x="0px"
                          y="0px"
                          viewBox="0 0 240.823 240.823"
                          enableBackground="new 0 0 240.823 240.823"
                        >
                          <g>
                            <path
                              d="M57.633,129.007L165.93,237.268c4.752,4.74,12.451,4.74,17.215,0c4.752-4.74,4.752-12.439,0-17.179
                      l-99.707-99.671l99.695-99.671c4.752-4.74,4.752-12.439,0-17.191c-4.752-4.74-12.463-4.74-17.215,0L57.621,111.816
                      C52.942,116.507,52.942,124.327,57.633,129.007z"
                            />
                          </g>
                        </svg>
                        {this.props.texts["preview"]}
                      </button>
                    </Link>
                  )}
                </div> */}
              </div>
              <RugsWishListSidebar
                texts={this.props.texts}
                wishListHandler={this.wishListHandler}
                wishList={this.state.rugsWishList}
                stateParam={this.state}
              />
            </div>
          </div>
        </div>
        <RugsWishListMobileSidebar
          texts={this.props.texts}
          wishListHandler={this.wishListHandler}
          wishList={this.state.rugsWishList}
        />
      </div>
    );
  }
}
